import { useState } from 'react';
import styles from './show-more.module.less';
import { formatNumber } from '../../utils';
import ButtonText from '../button/button-text/ButtonText';

const showMoreByClick = 6;
const defaultShowCount = 6;
const ShowMore = ({
    items,
    listCreator,
    hideSteps,
    footer,
    alwaysShowButtonForDisplayingAll,
    allowClose,
    showCount: initialShowCount,
}) => {
    const [showCount, setShowCount] = useState(initialShowCount ?? defaultShowCount);

    const showMoreAction = () => {
        setShowCount(showCount + showMoreByClick);
    };

    const showLessAction = () => {
        setShowCount(initialShowCount ?? defaultShowCount);
    };

    const showAllAction = () => {
        setShowCount(items.length);
    };

    const slicedItems = items.slice(0, showCount);
    const isShowingAll = showCount >= items.length;
    const shouldShowButtonForDisplayingAll =
        hideSteps || alwaysShowButtonForDisplayingAll
            ? showCount < items.length
            : !isShowingAll && showCount + showMoreByClick <= items.length;

    const showClose = allowClose && showCount > initialShowCount;

    return (
        <>
            {listCreator(slicedItems)}
            {isShowingAll && footer}
            <div className={styles.buttonsWrapper}>
                {!hideSteps && !isShowingAll && (
                    <ButtonText onClick={showMoreAction} className={styles.showMoreButton}>
                        Vis flere
                    </ButtonText>
                )}
                {showClose && (
                    <ButtonText onClick={showLessAction} className={styles.showMoreButton}>
                        Vis færre
                    </ButtonText>
                )}
                {shouldShowButtonForDisplayingAll && (
                    <ButtonText onClick={showAllAction} className={styles.showMoreButton}>
                        Vis alle {formatNumber(items.length)}
                    </ButtonText>
                )}
            </div>
        </>
    );
};

export default ShowMore;
